// this file was copied from /marketing/resources. See the README in this directory for details
import * as React from 'react';

export const SvgIconExpand = (props: React.ComponentPropsWithoutRef<'svg'>) =>
  React.createElement(
    'svg',
    { fontSize: '2.4rem', width: '1em', height: '1em', viewBox: '0 0 24 24', ...props },
    <path
      d="M11.839 13.253l-5.392 5.392 3.978.265-1.768 1.768-5.303-.354L3 15.021l1.768-1.768.265 3.977 5.392-5.391 1.414 1.414zM11.839 10.425l5.391-5.392-3.977-.265L15.021 3l5.303.354.354 5.303-1.768 1.768-.265-3.978-5.392 5.392-1.414-1.414z"
      fill="currentColor"
    />
  );
export default SvgIconExpand;
